import { Grid, Tabs, Tab, Typography } from "@mui/material";
import React, { useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";

const ViewClientNav = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  // Define the routes and their corresponding labels
  const routes = [
    {
      path: "/call-center/view-client/call-center/view-clients",
      label: "View Clients",
    },
    {
      path: "/call-center/view-client/call-center/opd-clients",
      label: "OPD Clients",
    },
    {
      path: "/call-center/view-client/call-center/success-clients",
      label: "Success Clients",
    },

    {
      path: "/call-center/view-client/call-center/all-clients",
      label: "All Clients",
    },
  ];

  // Handle tab change
  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
    navigate(routes[newValue].path); // Navigate to the selected route
  };

  // Determine the currently selected tab based on the URL
  const currentPath = location.pathname;
  const currentIndex = routes.findIndex((route) => route.path === currentPath);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} mt={1}>
        <Tabs
          value={currentIndex !== -1 ? currentIndex : 0}
          onChange={handleChange}
          centered
          textColor="secondary"
          indicatorColor="secondary"
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            backgroundColor: "#f5f5f5",
            borderRadius: 2,
            boxShadow: 1,
          }}
        >
          {routes.map((route, index) => (
            <Tab
              key={index}
              label={route.label}
              sx={{
                fontWeight: "bold",
                "&.Mui-selected": {
                  backgroundColor: "#e0e0e0",
                  borderRadius: "4px",
                  color: "#1976d2",
                },
                "&:hover": {
                  backgroundColor: "#e0e0e0",
                },
              }}
            />
          ))}
        </Tabs>
      </Grid>

      <Grid item xs={12}>
        <Outlet />
      </Grid>
    </Grid>
  );
};

export default ViewClientNav;
